import { memo } from 'react';
import { SidebarBoxKey } from 'AdmissionsGuidance/StudentDashboard.types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane } from '@fortawesome/pro-solid-svg-icons/faPlane';
import { Text } from 'Text';
import { faCloudSlash } from '@fortawesome/pro-solid-svg-icons';
import { ImportantCtaBox } from '../../ImportantCtaBox';

function OfflineBoxComponent({ mobile }: { mobile?: boolean }) {
    return mobile ? <OfflineBoxMobilePresentation /> : <OfflineBoxPresentation />;
}

function OfflineBoxMobilePresentation() {
    const { t } = useTranslation('back_royal', { keyPrefix: 'offlineBox' });
    return (
        <div className="flex h-[25px] items-center justify-start bg-black px-4">
            <FontAwesomeIcon icon={faCloudSlash} className="me-2 text-xs text-white" />
            <Text weight="semibold" color="white" uppercase className="text-xs">
                {t('mobileHeader')}
            </Text>
        </div>
    );
}

function OfflineBoxPresentation() {
    const { t } = useTranslation('back_royal', { keyPrefix: 'offlineBox' });
    return (
        <ImportantCtaBox
            headerSubtitle={t('headerSubtitle')}
            headerTitle={t('headerTitle')}
            boxKey={SidebarBoxKey.offline}
            icon={<FontAwesomeIcon icon={faPlane} />}
            iconCircle
        >
            {t('description')}
        </ImportantCtaBox>
    );
}

export const OfflineBox = memo(OfflineBoxComponent);
